import React, { useState } from 'react';
import { BookingsTableData, BookingTableCellProps } from './helpers';
import styles from './BookingsTable.module.css';
import { Popover } from '@round/ui-kit';

const ReasonsToBlockApprovalCell = <T extends BookingsTableData>({
    row,
}: BookingTableCellProps<T> & { className?: string }) => {
    const [reasonsTextRef, setReasonsTextRef] = useState<HTMLSpanElement | null>(null);
    const reasonsToBlock = row.original.reasons_to_block_approval_to_bill;

    if (reasonsToBlock?.length) {
        return (
            <>
                <span ref={setReasonsTextRef} className={styles.approveToBillValidationError}>
                    {reasonsToBlock.length > 1 ? `Blocked (${reasonsToBlock.length})` : reasonsToBlock[0]}
                </span>
                <Popover disabled={reasonsToBlock.length < 2} anchorElement={reasonsTextRef} showOn="hover">
                    <div className={styles.tooltip}>
                        {reasonsToBlock.map((reason) => (
                            <p key={reason} className={styles.approveToBillValidationError}>
                                {reason}
                            </p>
                        ))}
                    </div>
                </Popover>
            </>
        );
    }

    return null;
};

export default ReasonsToBlockApprovalCell;
